import React, { useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Typography,
  Stack,
  IconButton,
  Paper,
} from "@mui/material";
import { makeStyles } from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import * as MdIcons from "react-icons/md";

const useStyles = makeStyles(() => ({
  tableCenter: {
    display: "flex !important",
    justifyContent: "center !important",
  },
  stack: {
    backgroundColor: "#ffff",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "12px",
    padding: "12px",
    boxShadow: "0px 2px 6px #0000000a",
    // height: "180px",
    // [theme.breakpoints.down("md")]: {
    //   height: "230px",
    // },
  },
  balance: {
    fontSize: "30px !important",
    fontWeight: "bold !important",
    color: "#006EFF",
  },
  paperDownload: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#4CAF50 !important",
    borderRadius: "10px",
    padding: "8px",
    cursor: "pointer",
  },
}));

export default function ClientsTable(props) {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const headCells = [
    { label: "Prénom", id: "firstName" },
    { label: "Nom", id: "lastNale" },
    { label: "Id", id: "id" },
    { label: "Email", id: "email" },
    { label: "Téléphone", id: "phone" },
    { label: "Nombre de transactions", id: "transac" },
    { label: "Montant total des transactions", id: "montant" },
  ];

  const listSuccessTransac = props.clients || []; // Use an empty array as fallback if referralEarnings is not provided

  // Filter the transactions based on the search query
  const filteredTransactions = listSuccessTransac.filter((transaction) => {
    const fullName =
      `${transaction.first_name} ${transaction.last_name}`.toLowerCase();
    return fullName.includes(searchQuery.toLowerCase());
  });

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, filteredTransactions.length - page * rowsPerPage);

  return (
    <Grid container spacing={4} alignItems="center">
      <Grid item xs={12} sm={6}>
        <TextField
          label="Rechercher un client"
          value={searchQuery}
          onChange={handleSearch}
          fullWidth
          margin="normal"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <IconButton>
                <SearchIcon />
              </IconButton>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "16px" }}>
        <Paper className={classes.paperDownload} elevation={0}>
          <IconButton 
            onClick={props.onExport} 
            disabled={props.exportLoading} 
            sx={{ color: "white" }}
          >
            <MdIcons.MdOutlineFileDownload color="white" size={24} />
          </IconButton>
        </Paper>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Stack direction="row" alignItems="center" className={classes.stack}>
          <Typography variant="subtitle1">Nombre de clients</Typography>
          <Typography className={classes.balance}>{props.number}</Typography>
        </Stack>
      </Grid>

      <Grid item xs={12}>
        <TableContainer>
          <Table
            sx={{
              boxShadow: 2,
              borderRadius: "10px",
              bgcolor: "#fff",
            }}
          >
            <TableHead>
              <TableRow>
                {headCells.map((headCell) => (
                  <TableCell align="center" key={headCell.id}>
                    {headCell.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? filteredTransactions.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : filteredTransactions
              ).map((transaction, i) => (
                <TableRow
                  key={i}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell align="center">{transaction.first_name}</TableCell>
                  <TableCell align="center">{transaction.last_name}</TableCell>
                  <TableCell align="center">
                    {transaction.customer_id}
                  </TableCell>
                  <TableCell align="center">
                    {transaction.customer?.merchants_promotions !== 0 ? transaction.customer?.email || "-" : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {transaction.customer?.merchants_promotions !== 0 ? transaction.customer?.phone || "-" : "-"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      justifyContent: "center",
                    }}
                  >
                    {transaction.count}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                    }}
                  >
                    {transaction.total}
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={7} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredTransactions.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Grid>
    </Grid>
  );
}
